import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"

import { axiosInstance } from "@/lib/api-client"
import { API_ROUTES } from "@/lib/api-routes"

import type { Dashboard, DashboardRange } from "../types"

/**
 * One-call landing-dashboard snapshot. Keyed by range so switching 24h/7d
 * swaps only the chart; `keepPreviousData` holds the current view (no
 * skeleton flash) while the new range loads. Refreshed at the ~15s server
 * cache cadence — true-live per-lane calls are overlaid over SSE.
 */
export function dashboardQueryOptions(range: DashboardRange) {
  return queryOptions({
    queryKey: ["dashboard", range],
    queryFn: async () => {
      const res = await axiosInstance.get<Dashboard>(API_ROUTES.DASHBOARD, {
        params: { range },
      })
      return res.data
    },
    refetchInterval: 15_000,
    placeholderData: keepPreviousData,
  })
}

export function useDashboardQuery(range: DashboardRange) {
  return useQuery(dashboardQueryOptions(range))
}
